import WResultsFirst from './WResultsFirst'

export default WResultsFirst
